// extracted by mini-css-extract-plugin
module.exports = {"servicesGroupWrapper":"services-group_servicesGroupWrapper__c1mw6","sectionFlex":"services-group_sectionFlex__YPwfk","servicesImage":"services-group_servicesImage__2Jo7t"};